// breadcrumbs.js - Pastikan file ini ada di folder yang sama dengan Main.jsx
export const generateBreadcrumbs = (activePath, menuItems) => {
  const breadcrumbs = [];
  
  // Tambahkan Home sebagai item pertama
  breadcrumbs.push({
    label: "Dashboard",
    href: "/",
    isActive: false
  });

  // Cari menu item yang sesuai dengan activePath
  const findMenuItemByPath = (items, path) => {
    for (const item of items) {
      // Jika item ini memiliki path dan cocok
      if (item.path && item.path === path) {
        return item;
      }
      
      // Jika item ini punya subItems, cari di dalamnya
      if (item.subItems && item.subItems.length > 0) {
        const found = findMenuItemByPath(item.subItems, path);
        if (found) {
          return {
            ...item,
            subItem: found
          };
        }
      }
    }
    return null;
  };

  const foundItem = findMenuItemByPath(menuItems, activePath);
  
  if (foundItem) {
    // Jika ditemukan subItem (menu collapsible)
    if (foundItem.subItem) {
      breadcrumbs.push({
        label: foundItem.text,
        href: foundItem.path || "#", // Berikan path utama jika ada
        isActive: false
      });
      
      breadcrumbs.push({
        label: foundItem.subItem.text,
        href: foundItem.subItem.path,
        isActive: true
      });
    } else {
      // Menu biasa
      breadcrumbs.push({
        label: foundItem.text,
        href: foundItem.path,
        isActive: true
      });
    }
  } else {
    // Untuk path yang tidak ditemukan di menu, coba parsing manual
    const pathParts = activePath.split('/').filter(Boolean);
    
    if (pathParts.length > 0) {
      // Coba tebak nama menu dari path
      const lastPart = pathParts[pathParts.length - 1];
      const readableName = lastPart
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      
      breadcrumbs.push({
        label: readableName,
        href: activePath,
        isActive: true
      });
    }
  }

  return breadcrumbs;
};